import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom"; 
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css'; 
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css'; 
import Select from "react-select";


const StockVerification = () => {
     

    const handleCheckboxChange = () => {
        checkIsChecked(!Checked);
    };
    const [Checked, checkIsChecked] = useState(false);


    const [itemcat, setrawMaterial] = useState([{ id: Date.now() }]);
    // Add new IP configuration
    const handleAddConfig = () => {
        setrawMaterial([...itemcat, { id: Date.now() }]);
    };

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };


    const raw_material = [
        { value: "1", label: "Tomoto" },
        { value: "2", label: "Basmathi Rice" },
        { value: "3", label: "Red chilli powder" },
    ];
 
    const handleDeleteConfig = (id) => {
        setrawMaterial(itemcat.filter(config => config.id !== id));
    };
 
    const tableRef = useRef(null);
 
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const ConfirmationModal = () => {
        swal.fire({
            html: `
                        <div class="alert alert-success px-2 py-2" role="alert">
                            Are You Sure Want to Update Stock Checklist
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <label class="text-center"><b>(12-May-2025 to 19-May-2025)</b></label>
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" 
                            // viewBox="0 0 48 48" width="48" height="48">
                            // <defs>
                            // <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                            // </style></defs>
                            // <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            // <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                            // <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                            // <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                            // <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                            // <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                            // <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                            // </svg>
                        </div>
                                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(() => {
            window.location.href = './manage-stocks';
        });

    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Stock Verification</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item ">Purchase Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Stock</li>
                    </ol>
                </div>
            </div>
            <div>
                <div className='text-danger fs-3 font-w500 text-center mb-3'> Stock Checklist Verification  </div>
                <div className="table-container"  >
                    <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-5px'>
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckboxChange}
                                        className="form-check-input me-3"
                                        id="customCheckBox1"
                                        required

                                    />
                                </th>
                                <th className='min-w-100px'>Raw Material/Purchased Date</th>
                                <th className='min-w-100px'>Purchased/Consumed Stock</th>
                                <th className='min-w-100px'>Storage/Kitchen Room</th>
                                <th className='min-w-100px  text-center'>Last Consumed</th>
                                <th className='min-w-100px text-center'>Status</th>
                                
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            <tr>
                                <td>
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckboxChange}
                                        className="form-check-input me-3"
                                        id="customCheckBox1"
                                        required

                                    />
                                </td>
                                <td>
                                    <label className='text-danger font-w500 fs-7'>
                                        12-May-2025
                                    </label>
                                </td>

                                <td>
                                    <label className='text-black font-w400 fs-7'>
                                        Tomato
                                    </label>
                                </td>
                                <td className='text-center'>
                                    <label className='text-black font-w400 fs-7'>
                                        <span className='me-2'>20</span>
                                        <span>kg's</span>
                                    </label>
                                </td>
                                <td className='text-center'>
                                    <label className='text-black font-w400 fs-7'>
                                        <span className='me-2'>22</span>
                                        <span>kg's</span>
                                    </label>
                                </td>
                                <td className='text-center'>
                                    <label className='text-black font-w400 fs-7'>
                                        <span className='me-2'>2</span>
                                        <span>kg's</span>
                                    </label>
                                </td>
                           
                            </tr> 
                        </tbody>
                    </table>
                </div>
                <div className='row d-flex justify-content-end'>
                    <div className='col-lg-4'>
                        <div className='row mt-3'> 
                            <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                <div className='col-lg-11 text-black font-w500 fs-6'>Checked Raw Material Count</div>
                                <div className='col-lg-1'>
                                    <label className='text-green font-w700 fs-5'>
                                        5
                                    </label>
                                </div>
                            </div>
                            <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                <label className='col-lg-11 text-black font-w500 fs-6'>Mismatched Raw Material Count</label>
                                <div className='col-lg-1'>
                                    <label className='text-danger font-w700 fs-5'>
                                        1
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-12'>
                        <div className='row'>
                            <div className='scroll-y mh-350px py-2'>
                                <div className="col-lg-12 mb-3">
                                    <div className="mb-0">
                                        {itemcat.map(config => (
                                            <div key={config.id} data-repeater-item>
                                                <div className="row">
                                                    <div className="col-lg-2 mb-4">
                                                        <label className="text-black font-w500 fs-7">Raw Material</label>
                                                        <Select
                                                            placeholder="Select"
                                                            // defaultValue={selectedOption}
                                                            options={raw_material}
                                                            styles={{
                                                                ...customStyles,
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                    <div className='col-lg-5'>
                                                        <label className="text-black font-w500 fs-7">Description</label>
                                                        <textarea type="text" className="form-control" placeholder="Enter Description" />
                                                    </div>
                                                    <div className="col-lg-2 mb-1 px-1 py-1">
                                                        {itemcat.length > 1 && (
                                                            <button
                                                                className="btn btn-danger mt-4 px-2 py-2"
                                                                onClick={() => handleDeleteConfig(config.id)}
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="top"
                                                                title="Delete"
                                                            >
                                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mb-1 mt-1">
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={handleAddConfig}
                                        >
                                            <span><i className="fa-solid fa-plus fs-6"></i></span>
                                            <span className='ms-2 fs-7'>Add More</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4 pt-2">

                    <Link to={'/manage-stocks'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                    <Link to={'#'} onClick={ConfirmationModal} type="submit" className="btn btn-sm btn-primary">Submit</Link>
                </div>
            </div>






        </>
    )


}
export default StockVerification;